import store from 'store'
import { readyForReview, recordUser, submitApplication } from 'application'
import { updateProfileFromServer } from 'user'
import { bindForm, throttle, calculateAge, oncreateorupdate } from 'utils'
import flat from 'flat'

const getState = () => store.getState().application

// TODO inner layout with "back" and steps

const isForSelf = () => {
  const { who } = getState()
  if(who == null) return who
  return who === 'self'
}
const DEPARTMENTS_INFO = i.freeze([
  { key: 'cast', label: 'Cast', filter: ({ ageThen }) => ageThen > 11, questionKeys: [ 'applicant.gender' ] }
  , { key: 'band', label: 'Band', filter: ({ ageThen }) => ageThen > 11, questionKeys: [ 'applicant.instrument' ] }
  , { key: 'tech', label: 'Tech', filter: ({ ageThen }) => ageThen > 15, questionKeys: [ 'applicant.department' ] }
  , { key: 'foh', label: 'Front of house' }
])

function setInvalidOnCondition(vnode, fn, ...args) {
  const dom = vnode.dom.querySelector('input')
  if(!dom) return
  dom.setCustomValidity(fn(...args))
}

function getAtLeastOneValidator(data) {
  if(Object.keys(data).filter( (k) => data[k]).length === 0) {
    return 'Please select at least one value'
  } else {
    return ''
  }
}

const FORM = i.freeze([
  {
    key: 'applicant.gender'
    , getVnode: (applicant) => m.fragment({ key: 'applicant.gender' }, [
      m('div'
        , m('label', { class: 'form-radioXXX' }, 'Male', m('input', { type: 'radio', name: 'applicant.gender', value: 'male', checked: applicant.gender === 'male'  })))
      , m('div'
        , m('label', { class: 'form-radioXXX' }, 'Female', m('input', { type: 'radio', name: 'applicant.gender', value: 'female', checked: applicant.gender === 'female' })))
      , m('div'
        , m('label'
          , 'Other'
          , m('input', { required: true, type: 'radio', name: 'applicant.gender', value: 'other', checked: applicant.gender === 'other' }, 'Other, please specify:')
          , m('input', { class: 'form-input', required: true, name: 'applicant.gender:other', checked: applicant['gender:other'], disabled: applicant.gender !== 'other', value: applicant['gender:other'] || '' }))) ])
  }
  , {
    key: 'applicant.instrument'
    , getVnode: (applicant) => {
      const { instrument = {} } = applicant
      return m('div'
        , { key: 'band' }
        , m('h4', 'Instruments')
        , m('div'
          , m('label', { class: 'form-checkboxXXX' }, 'Guitar', m('input', { type: 'checkbox', name: 'applicant.instrument', value: 'guitar', checked: instrument.guitar })))
        , m('div'
          , m('label', 'Experience', m('input', { class: 'form-input', required: true, name: 'applicant.instrument:experience', value: applicant['instrument:experience'] || '' })))) /*TODO*/
    }
  }
  , {
    key: 'applicant.department'
    , getVnode: ({ department = {} }) => m('div'
        , { key: 'applicant.department' }
        , m('h4', 'Tech department')
        , m('div'
          , oncreateorupdate( (vnode) => setInvalidOnCondition(vnode, getAtLeastOneValidator, department))
          , m('div', m('label', { class: 'form-checkboxXXX' }, m('input', { type: 'checkbox', name: 'applicant.department', value: 'props', checked: department.props }), 'Props'))
          , m('div', m('label', { class: 'form-checkboxXXX' }, m('input', { type: 'checkbox', name: 'applicant.department', value: 'makeup', checked: department.makeup }), 'Makeup'))))
  }
  , {
    key: 'applicant.wwc'
    , allRoles: true
    , filter: ({ ageThen }) => ageThen >= 18
    , getVnode: (applicant) => m.fragment({ key: 'applicant.wwc' }, [
      m('div'
        , oncreateorupdate( (vnode) => setInvalidOnCondition(vnode, () => applicant['wwc:state'] ? '' : 'Please select an option.'))
        , m('h5', 'Working with children card')
        , m('div', m('label', `I don't have one.`, m('input', { type: 'radio', name: 'applicant.wwc:state', value: 'no', checked: applicant['wwc:state'] === 'no' })))
        , m('div', m('label', 'I have one.', m('input', { type: 'radio', name: 'applicant.wwc:state', value: 'yes', checked: applicant['wwc:state'] === 'yes' })))
        , m('div'
          , m('label'
          , 'WWC number'
          , m('input', { class: 'form-input', disabled: !!(applicant['wwc:state'] !== 'yes' || applicant['wwc:unknown']), required: true, pattern: '[\\d-]+', name: 'applicant.wwc', value: applicant.wwc }))) /*TODO validation*/
        , m('div'
          , m('label'
          , { class: 'form-checkboxXXX' }
          , `I don't know my number.`
          , m('input', { disabled: applicant['wwc:state'] !== 'yes', name: 'applicant.wwc:unknown', value: '', type: 'checkbox', checked: applicant['wwc:unknown'] })))
        , applicant['wwc:state'] === 'no' || applicant['wwc:unknown'] === true
            ? m('div', `NOTE: you will not be able to join Camberwell Showtime until you provide this information. You will be able to continue and save this application, but you won't be apple to join the show until you provide your WWC number.`)
            : null
       )
    ])
  }
  , {
    key: 'other.name'
    , allRoles: true
    , filter: ({ ageThen }) => ageThen < 18
    , getVnode: (applicant, data) => m.fragment({ key: 'guardian' }, [
      m('h5', 'Parent/guardian information #1')
      , m('div'
        , m('label', 'Name'
          , m('input', {
            class: 'form-input'
            , placeholder: 'Odin'
            , required: true
            , name: 'other.preferredName'
            , value: [ 'other', 'preferredName' ].reduce( (obj, k) => obj ? obj[k] : obj, data) || '' }))) /*TODO*/
      , m('button', { class: 'btn', type: 'button' }, 'Add another guardian')
    ])
  }
  , {
    key: 'other.name'
    , allRoles: true
    , filter: ({ ageThen }) => ageThen < 18
    , getVnode: (applicant, data) => m.fragment({ key: 'guardian' }, [
      m('h5', 'Contact details')
      , m('div', `TODO: this is a note to self that maybe it's independent? And then associated with the parent/guardian/applicant? Allows for "other".`)
    ])
  }
])

function persistApplicant({ state }) {
  const data = flat.unflatten(state.vm.data, { overwrite: true })
  store.dispatch({ type: 'application/PATCH', data: i.updateIn(data, [ 'applicant' ], (val) => {
    if(!val) return val
    const { dob } = val
    return { ...val, dob, ageNow: calculateAge(dob), ageThen: calculateAge(dob, new Date()) } // TODO FINDME
  })})
}

const wizard = [
  {
    view({ attrs: { incStep } }) {
      return m('div'
        , m('h3', 'Who is this application for?')
        , m('button', { class: 'btn', onclick: () => incStep(recordUser('self')) }, 'Me')
        , m('button', { class: 'btn', onclick: () => incStep(recordUser('other')) }, 'Someone else')
        , m('h5', 'Huh?')
        , m('p'
          , 'Camberwell Showtime is a heap of fun for all of us!'
          , m('br')
          , `Maybe you're "just" applying for your kids?`
          , m('br')
          , 'Think about it, and then treat yourself — come back and apply for yourself as well!'
          , m('br')
          , `It's super rewarding, heaps of fun, and a great volunteering experience!`))
    }
  }
  , {
    oninit({ state }) {
      const { data } = getState()
      state.vm = { data }
    }
    , view(vnode) {
      const { state, attrs: { decStep, incStep } } = vnode
      const { data } = state.vm
      const { applicant, other } = data
      const throttledPersist = throttle( () => persistApplicant(vnode), 100)
      const _isForSelf = isForSelf()
      if(_isForSelf == null) {
        decStep()
        return
      }
      return m('div'
        , m('form', {
            oninput: bindForm(state, { path: [ 'data' ], onchange: throttledPersist })
            , onchange: bindForm(state, { path: [ 'data' ], onchange: throttledPersist })
            , onsubmit: (e) => {
              e.preventDefault()
              incStep() // TODO FINDME DONT COMMIT
            }
          }
          , m('h2', 'Applicant details')
          , m('div'
            , m('label', { class: 'form-label', for: 'applicant.preferredName' }, 'Preferred name')
            , createInput('applicant.preferredName', { required: true, placeholder: 'Eddie the Eagle' }))
          , m('div'
            , m('label', { class: 'form-label', for: 'applicant.legalName' }, 'Legal name (if different)')
            , createInput('applicant.legalName', { placeholder: 'Dexter' }))
          , m('div'
            , m('label', { class: 'form-label', for: 'applicant.surname' }, 'Surname')
            , createInput('applicant.surname', { required: true, placeholder: 'Fletcher' }))
          , m('div'
            , m('label', { class: 'form-label', for: 'applicant.dob' }, 'Date of birth')
            , createInput('applicant.dob', { type: 'date', required: true }))
          , _isForSelf
            ? null
            : [
              m('h2', 'Your details')
            , m('div'
              , m('label', { class: 'form-label', for: 'other.preferredName' }, 'Preferred name')
              , createInput('other.preferredName', { required: true, placeholder: 'Odin' })
              , m('div', m('label', { class: 'form-checkboxXXX' }, m('input', { type: 'checkbox', name: 'other.help', checked: !!(other ? other.help : false) }), `I'd like to help out`)))
            ]
          , m('button', { class: 'btn', type: 'button', onclick: () => decStep(persistApplicant(vnode)) }, 'Back') // TODO save data somewhere temporarily
          , m('button', { class: 'btn' }, 'Save and continue')))
      function createInput(key, opts) {
        return m('input', Object.assign({ class: 'form-input', key, id: key, name: key, oncreate: ({ dom }) => dom.value = i.getIn(data, key.split('.')) || '' }, opts))
      }
    }
  }
  , {
    view({ state, attrs: { decStep, incStep } }) {
      const self = isForSelf()
      if(self == null) {
        decStep()
        return
      }
      const { applicant } = getState().data
      if(!applicant) {
        decStep()
        return m(Loading)
      }
      const { roles = {} } = applicant
      const { preferredName: name } = applicant
      if(!name) {
        decStep()
        return m(Loading)
      }
      return m('div',
        m('h2', `What ${self ? 'do you' : `does ${name}`} want to do in this year's show?`)
        , m('form', {
            onsubmit: (e) => {
              e.preventDefault()
              const rolesForSubmit = DEPARTMENTS_INFO
                .filter( ({ filter }) => filter ? !filter(applicant) : false)
                .reduce( (obj, { key }) => i.set(obj, key, false), roles)
              if(Object.keys(rolesForSubmit).filter( (k) => roles[k]).length === 0) {
                alert('Need to select at least one') // TODO
                return
              }
              store.dispatch({ type: 'application/SET_ROLES', data: rolesForSubmit })
              incStep()
            }
          }
          , DEPARTMENTS_INFO
            .filter( ({ filter }) => filter ? filter(applicant) : true)
            .map( ({ key, label }) => m('div'
              , m('label'
                , { class: 'form-checkboxXXX' }
                , createInput(key, { checked: roles[key], onchange: ({ target: { checked } }) =>
                    store.dispatch({ type: 'application/SET_ROLES', data: i.set(roles, key, checked) }) })
                , label)))
          , m('button', { class: 'btn', type: 'button', onclick: decStep }, 'Back')
          , m('button', { class: 'btn' }, 'Save and continue')))
      function createInput(key, opts) {
        return m('input', Object.assign({ key, id: key, name: key, type: 'checkbox' }, opts))
      }
    }
  }
  , {
    oninit({ state }) {
      const { data } = getState()
      state.vm = { data }
    }
    , view(vnode) {
      const { state, attrs: { decStep, incStep } } = vnode
      const self = isForSelf()
      const { data } = getState()
      const { applicant } = data
      const { roles } = applicant || {}
      if(!(applicant && roles)) {
        decStep()
        return m(Loading)
      }
      const { preferredName: name } = applicant
      const allQuestionKeys = new Set(Object.keys(roles)
                                      .filter( (k) => roles[k])
                                      .reduce( (arr, k) => arr.concat(DEPARTMENTS_INFO.find( ({ key }) => k === key).questionKeys || []), []))
      const fields = FORM
        .filter( ({ key, allRoles }) => allRoles || allQuestionKeys.has(key))
        .filter( ({ filter }) => filter ? filter(applicant) : true)

      const processChange = () => { // TODO this deserves to be placeholder
        persistApplicant(vnode)
        const { data } = getState()
        const { applicant } = data
        if( (applicant['wwc:state'] === 'no' || applicant['wwc:unknown']) && applicant['wwc']) {
          store.dispatch({ type: 'application/PATCH', data: i.setIn(data, [ 'applicant', 'wwc' ], null) })
        }
      }
      const fieldKeys = new Set(fields.map( ({ key }) => key))


      // TODO sections?
      return m('div'
        , m('form'
          , {
            oninput: bindForm(state, { path: [ 'data' ], onchange: processChange })
            , onchange: bindForm(state, { path: [ 'data' ], onchange: processChange, redraw: true })
            , onsubmit: (e) => {
              e.preventDefault()
              const { data } = getState()
              const newData = FORM.filter( ({ key }) => !fieldKeys.has(key))
                .reduce( (newData, { key }) => {
                  const [ type, mainKey ] = key.split('.')
                  return i.updateIn(newData, [ type ], (val = {}) => Object.keys(val || {}).filter( (k) => k === mainKey || k.startsWith(`${mainKey}:`)).reduce( (obj, k) => i.unset(obj, k), val))
                }, data)
              if(data !== newData) {
                store.dispatch({
                  type: 'application/PATCH'
                  , data: newData
                })
              }
              incStep()
            }
          }
          , m('div', fields.map( ({ getVnode }) => m('div', getVnode(applicant, data))))
            , m('button', { class: 'btn', type: 'button', onclick: decStep }, 'Back')
            , m('button', { class: 'btn' }, 'Save and continue')))
    }
  }
]

const ReviewPage = {
  view({ attrs: { decStep } }) {
    const { applicant } = getState().data
    const { wwc, ageNow } = applicant
    const ready = ageNow < 18 ? true : !!wwc
    return m('div'
      , m('h2', 'Review page')
      , m('p', 'Would allow modifying application.')
      , m('form'
        , {
          onsubmit: (e) => {
            e.preventDefault()
            const { applicant } = getState().data
            // TODO validation? or just rely on server side?
            // TODO submit info about "other"
            submitApplication(applicant)
              .catch( () => { debugger })
              .then(updateProfileFromServer)
              .then( () => m.route.set('/'))
          }
        }
        , m('pre', JSON.stringify(applicant, null, 2))
        , !ready ? m('p', `This application can't be submitted until the following information is updated: FINDME (wwc)`) : null
        , m('button', { class: 'btn', type: 'button', onclick: decStep }, 'Back')
        , m('button', { class: 'btn', disabled: !ready }, 'Join now!')))
  }
}

const REVIEW_STEP = wizard.length
const LAST_STEP = REVIEW_STEP - 1

const Page = {
  view({ attrs: { step: _step }}) {
    const parsedStep = parseInt(_step)
    const step = _step == null ? REVIEW_STEP : isNaN(parsedStep) ? REVIEW_STEP : parsedStep
    if(step > REVIEW_STEP) {
      m.route.set(`/apply/${REVIEW_STEP}`)
      return m(Loading)
    }
    return readyForReview() && step === REVIEW_STEP
      ? m(ReviewPage, { decStep })
      : m(wizard[Math.min(step, LAST_STEP)], { decStep, incStep })
    function incStep(fn) {
      if(typeof fn === 'function') fn()
      const nextStep = step + 1
      if(nextStep === REVIEW_STEP) {
        store.dispatch({ type: 'application/SET_READY_FOR_REVIEW', data: true }) // TODO?
        m.route.set(`/apply`)
      } else {
        m.route.set(`/apply/${nextStep}`)
      }
    }
    function decStep(fn) {
      if(typeof fn === 'function') fn()
      m.route.set(`/apply/${step - 1}`)
    }
  }
}

export const ApplyPage = Page

export default Page
